import React from 'react';
import styled from '@emotion/styled';
import { Button, Typography } from 'antd';
import { HomeWidgetsForm } from '../../../../types/home';
import { appStyles } from '../../../../styles';

interface InsightsPreviewProps {
  values: HomeWidgetsForm;
}

const { Text } = Typography;

export const InsightsPreview = (props: InsightsPreviewProps) => {
  const { values } = props;
  return (
    <StyledInsightsPreview>
      <Text className="heading">{values.heading}</Text>
      <Text className="title">{values.title}</Text>
      <br />
      {values.description && values.description.trim() && (
        <div className="wrap-description">
          <Text className="description">{values.description}</Text>
        </div>
      )}
      {values.ctaText && (
        <div className="wrap-btn">
          <Button className="ctaText">{values.ctaText}</Button>
        </div>
      )}
    </StyledInsightsPreview>
  );
};

const StyledInsightsPreview = styled.div`
  width: 75%;
  min-height: 297px;
  ${appStyles.borderGray}
  ${appStyles.borderRadiusModal}
  margin: 30% 12.5% 0;
  background: transparent linear-gradient(180deg, #7a91be 0%, #4e5157 100%) 0% 0% no-repeat padding-box;
  position: relative;
  padding: 0.75rem;
  & .heading {
    position: absolute;
    top: -48px;
    left: 0;
    font-size: 16px;
  }
  & .description {
    font-size: 16px;
    ${appStyles.color.white}
  }
  & .title {
    font-size: 14px;
    ${appStyles.color.white}
  }
  & .wrap-description {
    padding-bottom: 1rem;
    padding-top: 0.5rem;
    border-bottom: 1px solid #dedede;
  }
  & .wrap-btn {
    align-items: center;
    justify-content: center;
    display: flex;
  }
  & .ctaText {
    position: absolute;
    bottom: 1.2rem;
    border-radius: 10px;
    height: 36px;
  }
`;
